var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-random-generator-activated"},[_c('vue-scroll',{attrs:{"ops":_vm.vueScrollOptions}},_vm._l((_vm.randomApplicantsViewing.messages),function(message){return _c('div',{key:message.key},[_vm._v(" "+_vm._s(message.displayName)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }